import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Dispatch } from 'redux';
import { RootState } from '../../stores/store';
import { storeSortingState } from '../../stores/tables/actionCreators';
import { getSorting } from '../../stores/tables/selectors';
import { TableSorting } from '../../stores/tables/state';
import TableColumn from './TableColumn';

interface SelfProps extends React.HTMLAttributes<HTMLTableHeaderCellElement> {
    tableKey: string;
    column: string;
    refresh: () => void;
}
interface Props extends LocalizeContextProps, SelfProps {
    sorting: TableSorting;

    setSorting: (order?: 'asc' | 'desc') => void;
}

class TableSortableColumn extends React.Component<Props> {
    public render() {
        return (
            <TableColumn
                className="sortable clickable"
                onClick={this.setSorting}
            >
                <span>{this.props.children}</span>
                {this.props.sorting.column === this.props.column ?
                    (this.props.sorting.order === 'asc' ? (
                        <FontAwesomeIcon
                            className="ml-2"
                            icon={['fal', 'chevron-up']}
                        />
                    ) : (
                            <FontAwesomeIcon
                                className="ml-2"
                                icon={['fal', 'chevron-down']}
                            />
                        )) : undefined
                }
            </TableColumn>
        );
    }
    private setSorting = () => {
        if (this.props.sorting.column === this.props.column) {
            this.props.setSorting(this.props.sorting.order);
        } else {
            this.props.setSorting();
        }
    }
}

const mapStateToProps = (state: RootState, props: SelfProps) => ({
    sorting: getSorting(state, props.tableKey),
});

const mapDispatchToProps = (dispatch: Dispatch, props: SelfProps) => ({
    setSorting: (currentOrder?: 'asc' | 'desc') => {
        if (currentOrder === undefined) {
            dispatch(storeSortingState(props.tableKey, { column: props.column, order: 'asc' }));
        } else if (currentOrder === 'asc') {
            dispatch(storeSortingState(props.tableKey, {
                column: props.column,
                order: 'desc',
            }));
        } else {
            dispatch(storeSortingState(props.tableKey, {
                column: props.column,
                order: undefined,
            }));
        }
        props.refresh();
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(TableSortableColumn));